import { Stepper } from "@navigations/Stepper";

export enum SendMailStep {
  RECIPIENTS = 0,
  MAIL_CONTENT = 1,
}

interface ISendMailModalStepperProps {
  step: SendMailStep;
}

export const SendMailModalStepper = ({ step }: ISendMailModalStepperProps) => {
  return <Stepper steps={["(1/2) Destinataires", "(2/2) Contenu du courrier"]} activeStep={step} />;
};
